import React, { useEffect, useState } from "react";
import { Image, Form, Button } from "react-bootstrap";
import { Message, MessageHandlerDisplayType, useAppDispatch, SettingsMessages, AuthenticationTypes, MessageToastTypes } from "src/common";
import { Icon } from "src/components";
import { uiActions } from "src/store";
import passkeyImage from "src/assets/images/account/2fa/passkey-image.svg";
import securityKeyImage from "src/assets/images/account/2fa/securitykey-image.svg";
import smsImage from "src/assets/images/account/2fa/sms-image.svg";
import totpImage from "src/assets/images/account/2fa/totp-image.svg";
import webAuthKeyImage from "src/assets/images/account/2fa/webauthkey-image.svg";

type AllProps = {
  handleTwoFactorTypeChange: Function;
  auth_type: string;
  web_auth_key_type: string;
}

// Description: Component for changing two-factor login method
function AuthenticatorOptionsComponent(props: AllProps) {
  const { handleTwoFactorTypeChange, auth_type, web_auth_key_type } = props;
  const dispatch = useAppDispatch();
  const [key_title, setKeyTitle] = useState<string>(getKeyTitle());
  const [key_image, setKeyImage] = useState<string>(getKeyImage());
  const [key_message, setKeyMessage] = useState<string>(getKeyImage());

  useEffect(() => {
    setKeyTitle(getKeyTitle());
    setKeyImage(getKeyImage());
    setKeyMessage(getKeyMessage());
  }, [web_auth_key_type]);

  function getKeyTitle() {
    return web_auth_key_type === AuthenticationTypes.PASSKEY ? "PassKey" : web_auth_key_type === AuthenticationTypes.SECURITY_KEY ? "Security Key" : "Passkey or Security Key";
  }

  function getKeyImage() {  
    return web_auth_key_type === AuthenticationTypes.PASSKEY ? passkeyImage : web_auth_key_type === AuthenticationTypes.SECURITY_KEY ? securityKeyImage : webAuthKeyImage;
  }

  function getKeyMessage() {
    return web_auth_key_type === AuthenticationTypes.PASSKEY ? SettingsMessages.passkey_description : web_auth_key_type === AuthenticationTypes.SECURITY_KEY ? SettingsMessages.securitykey_description : SettingsMessages.webauthn_description;
  }

  // Description: Confirmation for changing the WebAuthn key
  function confirmEditWebAuthnKey() {
    const confirmation_dialog = new Message(
        SettingsMessages.web_auth_confirmation,
        MessageHandlerDisplayType.confirm,
        MessageToastTypes.primary,
        "Change Authentication Key?",
        {
            label: "Yes",
            data: true,
            action: () => { handleTwoFactorTypeChange(AuthenticationTypes.WEBAUTHN_CREDENTIAL, true); }
        }
    );
    dispatch(uiActions.handleSetMessage(confirmation_dialog));
  }
  
  return <Form className="two-factor-type">
    <div className={auth_type !== AuthenticationTypes.SMS ? "muted" : ""}>
      <Form.Check
        className="radio-button"
        defaultChecked={auth_type === AuthenticationTypes.SMS}
        onChange={(_ => handleTwoFactorTypeChange(AuthenticationTypes.SMS))}
        name="twoFactorType"
        type={"radio"}
      />
      <Image src={smsImage} onClick={(_ => handleTwoFactorTypeChange(AuthenticationTypes.SMS))}/>
      <div className="text-container">
        <p className="semi-bold">Text Message</p>
        <p>You will receive a one-time passcode.</p>
      </div>
    </div>
    <div className={auth_type !== AuthenticationTypes.TOTP ? "muted" : ""}>
      <Form.Check
        className="radio-button"
        defaultChecked={auth_type === AuthenticationTypes.TOTP}
        onChange={(_ => handleTwoFactorTypeChange(AuthenticationTypes.TOTP))}
        name="twoFactorType"
        type={"radio"}
      />
      <Image src={totpImage} onClick={(_ => handleTwoFactorTypeChange(AuthenticationTypes.TOTP))}/>
      <div className="text-container">
        <p className="semi-bold">Authenticator Application</p>
        <p>Set up your favorite authenticator app to log in to PreVeil.</p>
      </div>
    </div>
    <div className={auth_type !== AuthenticationTypes.WEBAUTHN_CREDENTIAL ? "muted" : ""}>
      <Form.Check
        className="radio-button"
        defaultChecked={auth_type === AuthenticationTypes.WEBAUTHN_CREDENTIAL}
        name="twoFactorType"
        type={"radio"}
        onChange={(_ => handleTwoFactorTypeChange(AuthenticationTypes.WEBAUTHN_CREDENTIAL))}
      />
      <Image src={key_image} onClick={(_ => handleTwoFactorTypeChange(AuthenticationTypes.WEBAUTHN_CREDENTIAL))} />
      <div className="text-container">
        <span className="d-flex"><p className="semi-bold me-2">{key_title}</p>{auth_type === AuthenticationTypes.WEBAUTHN_CREDENTIAL && <Button variant="icon" size="sm" onClick={confirmEditWebAuthnKey}><Icon className="icon-pencil"/></Button>}</span>
        <p>{key_message}</p>
      </div>
    </div>
    </Form>;
}

export default React.memo(AuthenticatorOptionsComponent);
